import { CalendarFilled, ClockCircleFilled  } from '@ant-design/icons';
import { I18nt } from 'utils';
import { Link } from 'react-router-dom';

import BannerWithImage from 'components/BannerWithImage';
import styles from './CitasMedicas.module.less';
import { paths } from 'config';


export default function CitasMedicas() {

  return (
    <section className={styles.consultaMedicamentos}>
      <BannerWithImage className={styles.background}>
        <div className={styles.wrapper}>
          <div className={styles.pageHeader}>
            <h4 className={styles.centerDesktop}>{I18nt('citas_medicas')}</h4>
            <p className={styles.centerDesktop}>{I18nt('programa_tus_citas')}</p>
          </div>
          <div className={styles.citasMenu}>
            <div className={`${styles.citasOption} ${styles.firstOption}`}>
              <Link className={styles.citasOptionHeader} to={paths.agendar_cita}>
                <div className={styles.iconBox}>
                  <CalendarFilled />
                </div>
                <h4>{I18nt('calendarizacion_de_citas_title')}</h4>
              </Link>
              <div className={styles.citasOptionBody}>
                <p>{I18nt('agendar_tus_proximas_citas')}</p>
              </div>
            </div>
            <div className={`${styles.citasOption} ${styles.lastOption}`}>
              <Link className={styles.citasOptionHeader} to={paths.historial_citas}>
                <div className={styles.iconBox}>
                  <ClockCircleFilled />
                </div>
                <h4>{I18nt('mis_citas')}</h4>
              </Link>
              <div className={styles.citasOptionBody}>
                <p>{I18nt('aqui_puedes_ver')}</p>
              </div>
            </div>
          </div>
        </div>
      </BannerWithImage>
    </section>
  );
}
